var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('van-sticky',[_c('van-nav-bar',{attrs:{"title":"Já foi concluído","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('div',{staticClass:"pay"},[_c('iframe',{ref:"myFrame",attrs:{"src":"","frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }